import React from "react";
import { Box } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import "../../../components-styles.scss";
import "../../profil-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputField from "../../../UIElements/InputField";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";

type EditNameFormProps = {
    onSubmit: Function;
    defaultValue?: {
        firstName: string;
        lastName: string;
    };
};

const validationSchema = yup.object({
    firstName: yup
        .string()        
        .required("Veuillez votre prénom."),
    lastName: yup
    .string()        
    .required("Veuillez votre nom."),
});

export default function EditNameForm({
    onSubmit,
    defaultValue,
}: EditNameFormProps) {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            firstName: defaultValue?.firstName ?? "",
            lastName: defaultValue?.lastName ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const _onSubmit = (data: any) => {
        onSubmit(data);
    };

    return (
        <Box className="profil-form-root">
            <form
                onSubmit={handleSubmit(_onSubmit)}
                className="profil-form-container"
            >
                <Controller
                    name="firstName"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            label={"Prénom"}
                            fullWidth
                            inputProps={{
                                type: "string",
                                maxLength: 255,
                            }}
                            outlinedinputsx={{
                                border: "2px solid  #E3E6E8",
                            }}
                            {...others}
                            errortext={errors.firstName?.message ?? ""}
                        />
                    )}
                />
                <Controller
                    name="lastName"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            label={"Nom"}
                            fullWidth
                            inputProps={{
                                type: "string",
                                maxLength: 255,
                            }}
                            outlinedinputsx={{
                                border: "2px solid  #E3E6E8",
                            }}
                            {...others}
                            errortext={errors.lastName?.message ?? ""}
                        />
                    )}
                />
                <CustomButton
                    type="submit"
                    label="Enregister"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </form>
        </Box>
    );
}
